<template>
  <div style="display: inline-block;">
    <span @click="submit()">
      <slot></slot>
    </span>
  </div>
</template>

<script>
import api from '../../../services/api.js'
let _ = require('lodash')

export default {
  name: 'AddAddress',
  props: ['order', 'packageId', 'groupOrderLine'],
  components: {
  },
  computed: {
  },
  data () {
    return {
    }
  },
  methods: {
    async submit () {
      let res = await api.post(this, {
        path: 'order.php',
        api: 'confirm_receipt',
        data: {
          order_id: this.order.id,
          package_id: this.packageId,
          update_time: this.order.update_time
        },
        loading: 'loading'
      })
      res = res.body
      if (res.status == 'ok') {
        this.order.update_time = res.result.update_time
        this.order.business_order_no = res.result.business_order_no
        this.groupOrderLine[0].done_time = res.result.done_time
        _.each(this.groupOrderLine, goods => {
          goods.status = '2'
        })
        let data = {
          confirm: true,
          operationType: '任务已完成'
        }
        this.$emit('complete', data)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .dialog-form {
    padding-bottom: 40px;
  }
  .tip {
    font-size:16px;
    color:rgba(136,136,136,1);
    line-height:24px;
    margin-bottom: 5px;
  }
  .add-tip {
    font-size:14px;
    color:rgba(102,102,102,1);
    line-height:24px;
    margin-left: 5px;
  }
  .back {
    float: left;
    color: #C0C4CC;
    font-size: 26px;
    line-height: 30px;
    cursor: pointer;
  }

  .select-address {
    padding-bottom: 7px;
    border-bottom: 1px solid #CDCDCD;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/OrderConfirm.vue